/**
 * Host-only (e.g. agents.dev.cusman.ai) → protocol-relative //host to match the page.
 * Full URL (http:// or https://) → use as-is so local http agents work behind an https app.
 *
 * Kept axios/interceptor-free so agents client can load without pulling in `store` (circular dep).
 */
function resolveAgentsBaseUrl(raw: string): string {
  const s = (raw ?? '').trim()
  if (!s) return ''
  if (/^https?:\/\//i.test(s)) {
    return s.replace(/\/$/, '')
  }

  return `//${s.replace(/^\/+/, '')}`
}

export const agentsBaseUrl = resolveAgentsBaseUrl(
  window.settings.BASE_AGENTS_DOMAIN
)
